<app-content-header [historyBack]="false" (backEvent)="onBack()" [headline]="'subscription_details' | i18next"></app-content-header>
@if (subscription && status && status.status !== 'api_loading') {
  <app-alert-message [alertType]="status.messageBg">
    @if (status.status === 'pbx_instance_paused') {
      <div>
        {{'instance_paused_due_to_payment_issues' | i18next: {date: subscription.pausedSince | localized_date,
        interpolation: {escapeValue: false} } }}
      </div>
    }
    @if (status.status !== 'pbx_instance_paused') {
      <div>
        {{ status.status | i18next }}
      </div>
    }
  </app-alert-message>
}
<app-subscription-cards [subscription]="subscription"></app-subscription-cards>

@if (hasTrunkCards || subscription?.isOne) {
  <h3 class="h3">{{'subscription_trunk_header' | i18next }}</h3>
}
@if (hasTrunkCards) {
  <div class="row align-items-stretch">
    @if (hasTariffDetail) {
      <div class="col-sm-12 col-md-6 mb-3">
        <app-tariff-card [isAdmin]="isAdmin" [subscription]="subscription"></app-tariff-card>
      </div>
    }
    @if (showItemizedBilling) {
      <div class="col-sm-12 col-md-6 mb-3">
        <app-subscription-itemized-billing [subscription]="subscription"></app-subscription-itemized-billing>
      </div>
    }
  </div>
}
@if (subscription?.isOne) {
  <div class="row align-items-stretch">
    <div class="col-sm-12 col-md-6 mb-3">
      <app-ai-tariff-card [isAdmin]="isAdmin" [subscription]="subscription"></app-ai-tariff-card>
    </div>
  </div>
}

@if (hasPhonenumbers) {
  <h3 class="h3">{{'phonenumber_list_headline' | i18next }}</h3>
  <div class="row align-items-stretch">
    @for (t of trunks; track t) {
      <app-phonenumber-card [clickable]="false" class="col-xs-12 col-md-6 col-lg-6 mb-3" [block]="t" [subscriptionInput]="subscription"></app-phonenumber-card>
    }
  </div>
  <p-confirmDialog #cd header="Confirmation" icon="pi pi-exclamation-triangle">
    <p-footer>
      <button type="button" class="btn btn-outline-primary" (click)="cd.reject()">{{'app_cancel' | i18next}}</button>
      <button type="button" class="btn btn-primary" (click)="cd.accept()">{{'app_delete' | i18next}}</button>
    </p-footer>
  </p-confirmDialog>
}

@if (hasIntegrationAppsBetaTag) {

  <div class="d-flex flex-row mt-5">
    <div class="h3">{{ 'subscription-view_installed_integration_apps_headline' | i18next }} ({{ installedIntegrationApps?.length }})</div>
    <div class="d-flex ml-auto align-items-center">
      <button name="show-marketplace" class="btn btn-outline-primary" [routerLink]="['/integration-apps', 'marketplace']" 
        [queryParams]="{ subId: subscription?.appliance_id, subName: subscription?.instance_name, installed: idsOfInstalledApps}">
        {{ 'subscription-view_integration_apps_marketplace_btn' | i18next}}</button>
    </div>
  </div>

  @if (hasIntegrationAppsInstallations) {
    <div class="row align-items-stretch mt-4">
    @for (installedApp of installedIntegrationApps; track $index) {
      <app-integration-apps-card class="col-xs-12 col-md-6 col-lg-6 mb-3" [integrationApp]="installedApp.app" [installationState]="installedApp.state">
        @if (isAdmin) {
          <div titlemenu>
            <div class="d-flex flex-row">
              <div class="custom-dropdown-menu ml-3" ngbDropdown display="dynamic" placement="bottom-right">
                <div class="btn bg-transparent p-0 m-0 hide-dropdown-icon" id="dropdownBasic2" ngbDropdownToggle>
                  <i class="fas fa-ellipsis-v icon-size-big"></i>
                </div>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
                  <div class="cursor-pointer dropdown-item" (click)="confirmUninstallation(installedApp.app.uuid)">
                    <span class="d-flex">
                      <i class="fa fa-ban red icon-size-big mr-2"></i>
                      <span>{{ 'subscription-view_integration_apps_uninstall_hint' | i18next }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </app-integration-apps-card>
    }
    </div>
  } @else {
    <app-no-content-message t="subscription-view_no_integration_apps_installed"></app-no-content-message>
  }

  <app-integration-apps-dialog [(showDialog)]="showDialog" [(contentType)]="dialogContentType" (uninstall)="startUninstallation()"></app-integration-apps-dialog>

}